import React, {SyntheticEvent } from 'react';
import Pagination from '@atlaskit/pagination';

interface PaginacaoProps {
  paginaAtual: number;
  paginas: number;
  onChange: (event: SyntheticEvent, newPage: any) => void;
}

export const Paginacao: React.FC<PaginacaoProps> = props => {
  const range = (n: number) => Array.from(Array(n).keys())

  const paginas = range(props.paginas+1)
  
  paginas.shift()

  if (props.paginas < 1) {
    return <></>
  }

  return (
    <Pagination
      selectedIndex={props.paginaAtual -1}
      pages={paginas}
      onChange={props.onChange}
      nextLabel='Anterior'
      previousLabel='Próximo'
      style={{'margin': '.8rem 0', 'justifyContent': 'center'}}
    />
  )
}